module.exports = __webpack_public_path__ + "assets/img/27_1285.c4f6d87f.jpg";